// src/components/ServiceBanner.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./ServiceBanner.css";

const ServiceBanner = () => {
  return (
    <section className="service-banner">
      <Container>
        <Row className="align-items-center">
          <Col md={12} className="text-content">
            <h2 className="banner-title">Services</h2>
            <p className="breadcrumb">
              Home <span> » </span> <span className="active">Services</span>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ServiceBanner;
